import { CardCore } from "src/Pages/components/CardCore/CardCore";

export const CardAsideProfile = () => {
  return <CardCore sxStyle={{ margin: 0 }}>Em breve</CardCore>;
};
